// extracted by mini-css-extract-plugin
export default {"home_container":"home_home_container__DAVo9","action_btn":"home_action_btn__BIPFL"};